// extracted by mini-css-extract-plugin
export default {"container":"WordGameLayout_container__B5S0Z","sub_container":"WordGameLayout_sub_container__J0WzS"};